export function heroSlider() {
    let $sliderConntainer = $(".hero-section");
    let dotContainerClass = ".hero-slider-nav";
    const header = $(".header");

    $sliderConntainer.each(function () {
        let slider = $(this).find(".hero-slider");

        slider.on("init.slick", function (event, slick) {
            const nextSlider = $(this).find("[data-slick-index=0]");
            const isDarkMast = nextSlider.find(".has-dark-overlay");

            if (isDarkMast.length) {
                header.addClass("white");
            }
        }).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            speed: 500,
            fade: true,
            autoplay: true,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            arrows: false,
            dots: true,
            appendDots: $(dotContainerClass),
        }).on("beforeChange", function (event, slick, currentSlide, nextSlide) {
            const nextSlider = $(this).find("[data-slick-index=" + nextSlide + "]");
            const isDarkMast = nextSlider.find(".has-dark-overlay");
            if (isDarkMast.length) {
                header.addClass("white");
            } else {
                header.removeClass("white");
            }
        });

        if (slider.find(".hero-slide").length >= 5) {
            $(dotContainerClass).addClass("short-lines");
        }
    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/heroSlider.js